import React, {Component} from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {Route, Switch, Redirect} from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';

import MainApp from 'routes/app'
import PageRegister from 'routes/register/'
import PageInformation from 'routes/information/'
import Framework from '@beardeddevops/react.framework';
import {resolveUseNewSidenav} from 'utils/sidenavOverride';

import PageForgotPassword from 'routes/forgot-password/'
import PageLogin from 'routes/login/'
import PageKiosk from 'routes/kiosk/'

import 'react-toastify/dist/ReactToastify.css';
import 'font-awesome/scss/font-awesome.scss';
import '@beardeddevops/react.framework/dist/index.css';

import lightTheme from './themes/lightTheme';
import 'constants/Styles.scss';

import API from "@beardeddevops/react.api";
import APPCONFIG from "constants/Config";
import Types from 'constants/Types';
import {defaultState} from 'constants/State';
import classNames from "classnames";
import {version} from '../../public/meta.json';
import BarcodeReader from 'react-barcode-reader';
import {guardOpenWorkOrderBeforeAdd} from '../utils/openWorkOrderWarning';

export default class App extends Component {

	constructor(props) {
		super(props);

		API.URL = APPCONFIG.settings.apiURL();
		API.Version = APPCONFIG.settings.apiVersion;
		console.log("logging init", API.URL, API.Version);
		let lockedLocations = ['/login', '/register', '/forgot-password', '/information', '/kiosk'];
		API.setAJAXDefaults(this, toast, lockedLocations);

		this.state = {
			shouldReloadCart: false,
			scannedCode: "",
			startLoading: false,
			hasLoaded: false,
			auto_cc_fee: false,
			apply_cc_fee_to_debit: true,
			location: null,
		};

		this.sessionCheckingInitialized = false;
		// noinspection JSUnusedGlobalSymbols
		this.scanner_current_product = "";

		if (this.props.rootState.shouldCacheBust) {
			window.onbeforeunload = function () {
				if (caches || this.props.rootState.shouldCacheBust) {
					// Service worker cache should be cleared with caches.delete()
					caches.keys().then(function (names) {
						for (let name of names) caches.delete(name);
					});
					localStorage.clear();
				}
			}
		}
	}

	async componentDidMount() {
		let {rootState} = this.props;
		this.rootStateID = rootState.subscribe({
			name: null,
			account: null,
			user: null,
			roles: null,
			account_name: null,
			location: null,
			locations: null,
			locations_count: null,
			sessions_count: null,
			session_items_count: null,
			ffl_boss_linked: null,
			fflboss_pos_combo: null,
			has_range_manager: false,
			auto_cc_fee: false,
			apply_cc_fee_to_debit: false,
			ffl_force_taxable: false,
			ammoready_linked: null,
			getUserInformation: this.getUserInformation,
			logout: this.handleLogout,
			logout_admin: this.handleLogoutAdmin,
			receiptCustomizationId: null,
			shouldCacheBust: false
		});

		await API.loadOptions(true, APPCONFIG.settings.apiVersion);

		await this.getUserInformation();

		this.setState({startLoading: true});

		// Initial routing is done, reload account info on route change
		this.props.history.listen(async () => {
			await this.getUserInformation();
		});

		//essentially a listener that won't f up in jquery land
		$(window).on('keydown.altC', (e) => {
			if (e.altKey && e.key.toLowerCase() === 'c') {
				// Navigate to checkout
				this.props.history.push('/checkout');
			}
		});

		// Dev-only keyboard toggle for old/new sidenav testing (Ctrl+Alt+N / Alt+N)
		//Plain Alt+N is swallowed by the Chrome menu accelerator on Windows, so Ctrl+Alt+N is the
		//reliable binding; plain Alt+N is also bound for when the browser does forward it.
		//The lock prevents a browser that forwards both combos from toggling twice.
		this.sidenavToggleLock = 0;
		const toggleSidenav = (e) => {
			if (e.key && e.key.toLowerCase() !== 'n') return;
			if (e.ctrlKey && !e.altKey) return;
			if (e.timeStamp - this.sidenavToggleLock < 500) return;
			this.sidenavToggleLock = e.timeStamp;
			e.preventDefault();
			const next = !resolveUseNewSidenav(this.state.use_new_sidenav);
			console.log(`Sidenav override -> ${next ? 'NEW' : 'OLD'} (Ctrl+Alt+N / Alt+N toggles, clear localStorage.override_new_sidenav to use account setting)`);
			this.applyUseNewSidenav(next);
		};
		$(window).on('keydown.sidenavToggle', (e) => {
			if (e.ctrlKey && e.altKey) toggleSidenav(e);
		});
		$(window).on('keydown.sidenavToggleAlt', (e) => {
			if (e.altKey && !e.ctrlKey) toggleSidenav(e);
		});
		this.handleSidenavPrefEvent = (event) => {
			this.applyUseNewSidenav(!!event.detail);
		};
		window.addEventListener('bpos-use-new-sidenav', this.handleSidenavPrefEvent);
	}

	applyUseNewSidenav = (next) => {
		const value = !!next;
		window.localStorage.setItem('override_new_sidenav', value ? '1' : '0');
		this.setState({use_new_sidenav: value});
	}

	componentWillUnmount() {
		this.props.rootState.unsubscribe(this.rootStateID);
		// Clean up jQuery event
		$(window).off('keydown.altC');
		$(window).off('keydown.sidenavToggle keydown.sidenavToggleAlt');
		window.removeEventListener('bpos-use-new-sidenav', this.handleSidenavPrefEvent);
	}

	handleLogout = () => {
		this.props.rootState.set({...defaultState});
		this.props.history.push('/login');
	}

	handleLogoutAdmin = () => {
		this.props.rootState.set({...defaultState});
		window.location.href = APPCONFIG.settings.adminURL();
	}

	getUserInformation = async () => {
		let {rootState} = this.props;

		// Kiosk uses its own auth; avoid GET_DETAILS / billing redirects / session redirect side-effects
		if (this.props.location.pathname === '/kiosk') {
			return;
		}

		let info = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		let data;

		try {
			data = await info.submit(null, 'GET_DETAILS');
		} catch (e) {
			console.log("e", e);
			return;
		}
		if (!data) {
			return;
		}

		/**
		 * @object data
		 * @property name_first
		 * @property name_last
		 * @property account_first
		 * @property account_last
		 */
		rootState.set({
			account: data.account,
			account_name: data.account_first + " " + data.account_last,
			user: data.user != null && data.user !== '' ? data.user : null,
			roles: data.user_access,
			name: data.name_first + ' ' + data.name_last,
			location: data.location,
			locations: data.locations,
			locations_count: data.locations_count,
			sessions_count: data.sessions_count,
			isAdmin: typeof data.admin !== 'undefined' ? data.admin : false,

			//This keeps resetting the item count to the number of checkout entries, when leaving checkout route
			session_items_count: data.session_items_count,
			ammoready_linked: data.ammoready_linked,
			ffl_boss_linked: data.ffl_boss_linked,
			fflboss_pos_combo: !!data.fflboss_pos_combo,
			altrupay_linked: data.altrupay_linked,
			invoicing_enabled: !!data.invoicing_enabled,
			auto_invoice: !!data.auto_invoice,
			pay_by_link_enabled: !!data.pay_by_link_enabled,
			auto_send_invoice_email: !!data.auto_send_invoice_email,
			invoices_overdue_30d_count: parseInt(data.invoices_overdue_30d_count, 10) || 0,
			receiptCustomizationId: data.recieptCustom,
			failedSubscription: data.failed_subscription,
			failedBilling: data.failed_billing,
			is_tactical: !!data.is_tactical,
			//Todo: its cause the api isnt returning the version number, thats why its failing
			// shouldCacheBust: parseInt(data.version.replaceAll('.', '')) > parseInt(version.replaceAll('.', ''))
			no_subscription: data.no_subscription,
			api_key_exists: data.api_key_exists,
			has_range_manager: !!data.has_range_manager,
			location_plan: data.location.StripePlan,
			cash_discounting: !!data.cash_discounting,
			cash_discount_percentage: data.cash_discount_percentage,
			allow_zelle: !!data.allow_zelle,
			allow_debit: !!data.allow_debit,
			apply_cc_fee_to_debit: data.apply_cc_fee_to_debit == null ? true : !!data.apply_cc_fee_to_debit,
			cash_discount_payment_types: Array.isArray(data.cash_discount_payment_types)
				? data.cash_discount_payment_types
				: ['cash'],
			register_audit_denominations: !!data.register_audit_denominations,
			register_require_variance_note: !!data.register_require_variance_note,
			retained_float: data.retained_float != null && data.retained_float !== '' && !Number.isNaN(parseFloat(data.retained_float))
				? parseFloat(data.retained_float)
				: null,
			register_default_denominations: data.register_default_denominations || null,
			quick_checkout_enabled: !!data.quick_checkout_enabled,
			auto_cc_fee: !!data.auto_cc_fee,
			ffl_force_taxable: !!data.ffl_force_taxable,
			skip_print_preview: !!data.skip_print_preview,
			show_customer_info: !!data.show_customer_info,
			show_tax_breakdown: !!data.show_tax_breakdown,
			//just in case this is null
		});

		//setting in rootState doesn't trigger re-renders
		this.setState({
			show_consignments: !!data.show_consignments,
			show_layaways: !!data.show_layaways,
			show_trade_ins: !!data.show_trade_ins,
			skip_print_preview: !!data.skip_print_preview,
			show_customer_info: !!data.show_customer_info,
			show_tax_breakdown: !!data.show_tax_breakdown,
			cash_discounting: !!data.cash_discounting,
			cash_discount_percentage: data.cash_discount_percentage,
			allow_zelle: !!data.allow_zelle,
			allow_debit: !!data.allow_debit,
			apply_cc_fee_to_debit: data.apply_cc_fee_to_debit == null ? true : !!data.apply_cc_fee_to_debit,
			cash_discount_payment_types: Array.isArray(data.cash_discount_payment_types)
				? data.cash_discount_payment_types
				: ['cash'],
			invoicing_enabled: !!data.invoicing_enabled,
			register_audit_denominations: !!data.register_audit_denominations,
			register_require_variance_note: !!data.register_require_variance_note,
			retained_float: data.retained_float != null && data.retained_float !== '' && !Number.isNaN(parseFloat(data.retained_float))
				? parseFloat(data.retained_float)
				: null,
			register_default_denominations: data.register_default_denominations || null,
			auto_cc_fee: !!data.auto_cc_fee,
			ffl_force_taxable: !!data.ffl_force_taxable,
			use_new_sidenav: resolveUseNewSidenav(data.use_new_sidenav),
			location: data.location || null,
		})

		if (this.props.rootState.shouldCacheBust) {
			if (!this.state.cacheInterval) {
				API.Toast.info('A new version is available, please refresh when you are able to.', {
					position: API.Toast.POSITION.TOP_RIGHT
				}); //Initial toast

				this.state.cacheInterval = setInterval(() => {
					API.Toast.info('A new version is available, please refresh when you are able to.', {
						position: API.Toast.POSITION.TOP_RIGHT
					});
				}, 300000)
			}
		}

		// if (location != null && data.locations_count === 0 && location.pathname !== '/locations') {
		// 	this.props.history.push('/locations');
		// }

		// Initialize services depending on an authenticated session
		await this.initSessionChecks();

		if (!data.fflboss_pos_combo
			&& (data.no_subscription || data.failed_billing)
			&& !APPCONFIG.settings.isStrictDevHost()
			&& !window.location.href.includes('settings#billing')) {
			this.props.history.push('/settings#billing');
		}
	}

	handleSessionCheck = async () => {
		const pathname = this.props.location.pathname;

		// Kiosk session is independent of POS account session; never run session redirect logic here
		if (pathname === '/kiosk') {
			return;
		}

		// If already logged into POS but still on an auth-only public page, enter the app
		const authLandingPaths = ['/login', '/forgot-password', '/information'];

		let check = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		let data;
		try {
			//TODO: might use this later
			data = await check.submit(null, 'GET_CHECK');
		} catch (e) {
			console.log('handleSessionCheck error: ', e);
			return;
		}

		if (data && authLandingPaths.includes(pathname)) {
			this.props.history.push('/');
		}
	}

	initSessionChecks = async () => {
		if (this.sessionCheckingInitialized) return;

		setInterval(async () => {
			await this.handleSessionCheck();
		}, 60000);

		await this.handleSessionCheck();

		this.sessionCheckingInitialized = true;
	}

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count: this.props.rootState.session_items_count === null ? 1 : 1 + this.props.rootState.session_items_count
		});
	}

	handleCustomerBarcodeCapture = (barcode) => {
		if (typeof window.BestPOSCustomerBarcodeCapture !== 'function') {
			return false;
		}

		return window.BestPOSCustomerBarcodeCapture(barcode) === true;
	}

	handleGiftCertificateBarcodeCapture = (barcode) => {
		if (typeof window.BestPOSGiftCertificateBarcodeCapture !== 'function') {
			return false;
		}

		return window.BestPOSGiftCertificateBarcodeCapture(barcode) === true;
	}

	lookupCustomerBarcode = async (barcode) => {
		try {
			const data = await $.ajax({
				type: "POST",
				url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/barcode_lookup',
				data: {
					object: JSON.stringify({
						barcode,
					}),
				},
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			return response && response.customer ? response : null;
		} catch (error) {
			return null;
		}
	}

	lookupGiftCertificateBarcode = async (barcode) => {
		try {
			const data = await $.ajax({
				type: "POST",
				url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/certificates/barcode_lookup',
				data: {
					object: JSON.stringify({
						barcode,
					}),
				},
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			return response && response.certificate ? response.certificate : null;
		} catch (error) {
			return null;
		}
	}

	processGiftCertificateScanner = (certificate, rawBarcode) => {
		if (!certificate || !certificate.pkey) {
			return false;
		}

		const pathname = this.props.history.location.pathname;
		if (pathname.indexOf('/certificates') === 0) {
			this.props.history.push('/certificates/' + certificate.pkey);
			return true;
		}
		if (pathname.indexOf('/checkout') === 0) {
			this.setState({
				scannedCode: {
					type: 'GC',
					id: certificate.pkey,
					rawBarcode,
					scanId: Date.now(),
				}
			});
			return true;
		}

		return false;
	}

	processCustomerScanner = (barcodeMatch, rawBarcode) => {
		const customer = barcodeMatch.customer;
		if (!customer || !customer.pkey) {
			return false;
		}

		if (this.props.history.location.pathname.indexOf('/checkout') === 0) {
			this.setState({
				scannedCode: {
					type: 'customer',
					customer,
					barcode: barcodeMatch.barcode,
					rawBarcode,
					scanId: Date.now(),
				}
			});
			API.ToastId = toast.info(customer.name + ' selected for checkout.', {
				position: toast.POSITION.TOP_RIGHT
			});
			return true;
		}

		this.props.history.push('/customers/' + customer.pkey);
		API.ToastId = toast.info(customer.name + ' customer card scanned.', {
			position: toast.POSITION.TOP_RIGHT
		});
		return true;
	}

	processScanner = async (product) => {
		product = String(product || '').trim();
		if (!product) {
			return;
		}

		if (this.handleCustomerBarcodeCapture(product)) {
			return;
		}
		if (this.handleGiftCertificateBarcodeCapture(product)) {
			return;
		}

		const customerBarcodeMatch = await this.lookupCustomerBarcode(product);
		if (customerBarcodeMatch && this.processCustomerScanner(customerBarcodeMatch, product)) {
			return;
		}

		//--- Certificate Handling ---
		const pathname = this.props.history.location.pathname;
		if (pathname.indexOf('/certificates') === 0 || pathname.indexOf('/checkout') === 0) {
			const certificate = await this.lookupGiftCertificateBarcode(product);
			if (certificate && this.processGiftCertificateScanner(certificate, product)) {
				return;
			}
		}

		const legacyCertificateMatch = product.match(/^GC-(\d+)$/i);
		if (legacyCertificateMatch) {
			this.processGiftCertificateScanner({pkey: legacyCertificateMatch[1]}, product);
			return;
		}
		// --- End Certificate Handling ---

		let originalProduct = product;
		let productType = product.split('-')[0];
		product = product.split('-')[1];

		// let rootState = this;
		if (product === '0001' || product === '0002' || product === '0003' || product === '0004' || product === '4' || product === '0005') {
			product = originalProduct.split('-')[2];
		}
		if (this.props.history.location.pathname === "/skus") {
			this.props.history.push("/skus/" + product);
		} else if (this.props.location.pathname.includes("/layaways")) {
			//do nothing here, let the layaway page handle scanning on its own
		} else {
			if (productType === 'P' || productType === 'p') {
				if (!this.props.rootState.ffl_boss_linked) {
					API.ToastId = toast.error('FFL Boss is not linked to this account.', {
						position: toast.POSITION.TOP_CENTER
					});
					return;
				}
				$.ajax({
					type: "PUT",
					url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/checkouts/products',
					data: {
						object: JSON.stringify({
							"checkout": "",
							"sku": product,
							"product": product,
							"serial": null,
							"quantity": 1
						}),
					},
					success: (data) => {
						API.ToastId = toast.info(data.response.product + ' added to cart.', {
							position: toast.POSITION.TOP_RIGHT
						});
						this.handleCheckoutIncrement();
					},
					error: function (xhr, status, error) {
						let errorMessage = xhr.responseJSON.response === 'Product is already in cart' ? xhr.responseJSON.response : 'We were unable to find that product you requested on your account.'
						API.ToastId = toast.error(errorMessage, {
							position: toast.POSITION.TOP_CENTER
						});
					}
				});
			}
			//if(productType === 'I') {
			else {
				const inventoryPkey = productType === 'I' ? product : null;
				const submitCheckoutItem = () => {
					$.ajax({
						type: "PUT",
						url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/checkouts/items',
						data: {
							object: JSON.stringify({
								"checkout": "",
								"sku": productType === 'I' ? product ?? originalProduct : originalProduct,
								"product": product ?? originalProduct,
								"serial": null,
								"quantity": 1
							}),
						},
						success: (data) => {
							API.ToastId = toast.info(data.response.inventories.skus.sku + ' added to cart.', {
								position: toast.POSITION.TOP_RIGHT
							});
							this.handleCheckoutIncrement();
						},
						//TODO: we dont need the product is already in cart special validation, need to get rid of in the future cause the backend wont even return it atm
						error: function (xhr, status, error) {
							let errorMessage = xhr.responseJSON.response === 'Product is already in cart' ? xhr.responseJSON.response : 'We were unable to find that product you requested on your account.'
							API.ToastId = toast.error(errorMessage, {
								position: toast.POSITION.TOP_CENTER
							});
						}
					});
				};
				if (inventoryPkey) {
					const proceed = await guardOpenWorkOrderBeforeAdd(inventoryPkey, 'This item');
					if (!proceed) {
						return;
					}
				}
				submitCheckoutItem();
			}
		}
		if (this.props.history.location.pathname === "/checkout") {
			this.props.history.push('/');
			this.props.history.push('/checkout');
		}
	}

	render() {
		let {match, location, rootState} = this.props;
		let {account} = rootState;
		let materialUITheme = lightTheme;
		let isRoot = location.pathname === '/';


		if (isRoot) {
			API.NoLoggedInNotice = false;
			let direct = '/dashboard';
			if (!account) {
				direct = '/login';
			}
			if (!window.location.href.includes('register')) {
				return (
					<Redirect to={direct}/>
				);
			}
		}
		let startLoading = this.state.startLoading;

		return (
			<MuiThemeProvider theme={createMuiTheme(materialUITheme)}>
				<div id="app-inner">
					<div className="preloaderbar hide">
						<span className="bar"/>
					</div>
					<div className='app-main full-height fixed-header sidebar-sm'>
						<BarcodeReader
							minLength={3}
							onScan={this.processScanner}
						/>
						{account ?
							<Switch>
								<Route path={`${match.url}`} render={
									(props) => <MainApp {...props} //Props From Route NOT from MainApp
									                    shouldReloadCart={this.state.shouldReloadCart}
									                    handleReloadCart={this.handleReloadCart}
									                    scannedCode={this.state.scannedCode}
									                    show_consignments={this.state.show_consignments}
									                    show_layaways={this.state.show_layaways}
									                    show_trade_ins={this.state.show_trade_ins}
									                    use_new_sidenav={resolveUseNewSidenav(this.state.use_new_sidenav)}
									                    invoicing_enabled={this.state.invoicing_enabled}
									                    auto_cc_fee={!!this.state.auto_cc_fee}
									                    apply_cc_fee_to_debit={this.state.apply_cc_fee_to_debit == null ? true : !!this.state.apply_cc_fee_to_debit}
									                    posLocation={this.state.location}
									                    skip_print_preview={this.state.skip_print_preview}
									                    show_customer_info={this.state.show_customer_info}
									                    show_tax_breakdown={this.state.show_tax_breakdown}
									/>
								}/>
								<Redirect to="/"/>
							</Switch>
							: startLoading ?
								<Switch>
									<Route exact path="/login" component={PageLogin}/>
									<Route exact path="/kiosk" component={PageKiosk}/>
									<Route exact path="/register" component={PageRegister}/>
									<Route exact path="/forgot-password" component={PageForgotPassword}/>
									<Route exact path="/information" component={PageInformation}/>
								</Switch>
								: <div className={classNames("tabled", "loader", 'active')}>
									<ClipLoader color={"#4A4A4A"} loading={true}/>
								</div>}
						<ToastContainer autoClose={10000} style={{textAlign: "center"}}/>
					</div>
				</div>
			</MuiThemeProvider>
		);
	}
}

App = Framework.Components.withRootState(App);
